import { Auth0ContextInterface } from "@auth0/auth0-react/dist/auth0-context";
import { LogoutOptions } from "@auth0/auth0-spa-js";

let getAccessTokenSilently: any = null;
let logout: null | Auth0ContextInterface["logout"] = null;

export const security = {
  getAccessTokenSilently: () => getAccessTokenSilently().catch(console.log),
  setAccessTokenSilently: (func: any) => {
    getAccessTokenSilently = func;
  },
  logout: (opions: LogoutOptions) => logout && logout(opions),
  setLogout: (func: Auth0ContextInterface["logout"]) => {
    logout = func;
  },
};
